import { render, staticRenderFns } from "./DropdownComponent.vue?vue&type=template&id=d3f8b12c&scoped=true"
import script from "./DropdownComponent.vue?vue&type=script&lang=js"
export * from "./DropdownComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f8b12c",
  null
  
)

export default component.exports